import products from "./utils/products.js";
import axios from "axios";
import _ from "lodash";

axios.defaults.withCredentials = true;

const full_public_form_urls = {
    "full.public.form.fresh_web_energy": "full.public.form.fresh_web_energy",
    "full.public.form.unsubscribe": "full.public.form.unsubscribe",
    "full.public.form.resubmit": "full.public.form.resubmit",
    "full.public.form.schedule": "full.public.form.schedule",
};

const form_urls = {
    "step.form.fresh_web_car": "step.form.fresh_web_car",
    "step.form.fresh_web_modified": "step.form.fresh_web_modified",
    "step.form.fresh_web_motor_bike": "step.form.fresh_web_motor_bike",
    "step.form.fresh_web_motor_home": "step.form.fresh_web_motor_home",
    "step.form.fresh_web_motor_trade": "step.form.fresh_web_motor_trade",
    "step.form.fresh_web_van": "step.form.fresh_web_van",
    "step.form.fresh_web_taxi": "step.form.fresh_web_taxi",
    "step.form.fresh_web_fleet": "step.form.fresh_web_fleet",
    "step.form.fresh_web_hgv": "step.form.fresh_web_hgv",
    "step.form.fresh_web_travel": "step.form.fresh_web_travel",
    "step.form.fresh_web_courier": "step.form.fresh_web_courier",
    "step.form.fresh_web_fast_food": "step.form.fresh_web_fast_food",
    "step.form.fresh_web_school": "step.form.fresh_web_school",
    "step.form.fresh_web_public_liability": "step.form.fresh_web_public_liability",
    "step.form.fresh_web_generic": "step.form.fresh_web_generic",
    "step.form.fresh_web_goods_in_transit": "step.form.fresh_web_goods_in_transit",
    "step.form.fresh_web_home": "step.form.fresh_web_home",
    "step.form.fresh_web_landlord": "step.form.fresh_web_landlord",
    "step.form.fresh_web_mini_bus": "step.form.fresh_web_mini_bus",
    "step.form.fresh_web_quad": "step.form.fresh_web_quad",
    "step.form.fresh_web_sme": "step.form.fresh_web_sme",
    "step.form.fresh_web_boat": "step.form.fresh_web_boat",
    "step.form.fresh_web_caravan": "step.form.fresh_web_caravan",
    "step.form.fresh_web_gap": "step.form.fresh_web_gap",
};
const page_urls = {
    "page.thank_you": "page.thank_you",
};
const STATE_LEAD_NEW = "new";
const STATE_LEAD_IN_PROGRESS = "in_progress";
const STATE_LEAD_CONVERTED = "converted";
const STATE_LEAD_PENDING = "pending";
const STATE_LEAD_SCHEDULED = "scheduled";

const STATE_CONVERSION_NEW = "new";
const STATE_CONVERSION_SUCCESS = "success";
const STATE_CONVERSION_FAILED = "failed";

const states = {
    STATE_LEAD_NEW,
    STATE_LEAD_IN_PROGRESS,
    STATE_LEAD_PENDING,
    STATE_LEAD_SCHEDULED,
    STATE_LEAD_CONVERTED,
    STATE_CONVERSION_NEW,
    STATE_CONVERSION_SUCCESS,
    STATE_CONVERSION_FAILED,
};

const config = {
    backend_url: "",
    setBackendUrl: function (url) {
        this.backend_url = url;
    },
    [products.car]: {
        drivers: 4,
        occupations: 2,
        claims: 4,
        mot_convictions: 4,
        vehicle_modifications: 4,
    },
    [products.modified]: {
        drivers: 4,
        occupations: 2,
        claims: 4,
        mot_convictions: 4,
        vehicle_modifications: 4,
    },
    [products.van]: {
        drivers: 4,
        occupations: 2,
        claims: 4,
        mot_convictions: 4,
    },
    [products.school]: {
        claims: 4,
    },
    [products.public_liability]: {
        occupations: 2,
    },
    [products.goods_in_transit]: {
        occupations: 2,
    },
    [products.courier]: {
        drivers: 4,
        claims: 4,
        occupations: 2,
        mot_convictions: 4,
    },
    [products.fleet]: {
        occupations: 2,
    },
    [products.travel]: {
        travellers: 50,
        medical_conditions: 5,
    },
    [products.taxi]: {
        drivers: 4,
        occupations: 2,
        claims: 4,
        mot_convictions: 4,
    },
    [products.hgv]: {
        drivers: 4,
        claims: 4,
        mot_convictions: 4,
    },
    [products.motor_trade]: {
        occupations: 2,
        claims: 4,
        mot_convictions: 4,
        vehicle_modifications: 4,
    },
    [products.motor_bike]: {
        occupations: 2,
        claims: 4,
        mot_convictions: 4,
    },
    [products.quad]: {
        occupations: 2,
        mot_convictions: 4,
    },
    [products.home]: {
        occupations: 2,
        claims: 4,
    },
    [products.landlord]: {},
    [products.mini_bus]: {
        occupations: 2,
    },
    [products.motor_home]: {
        occupations: 2,
        drivers: 4,
    },
    [products.caravan]: {
        occupations: 2,
        claims: 4,
    },
    states,
    states_finished: [
        states.STATE_LEAD_CONVERTED,
        states.STATE_LEAD_SCHEDULED,
        states.STATE_LEAD_PENDING
    ],
    form_urls,
    page_urls,
    full_public_form_urls,
};

// copy config for fresh_web_xxx and  products
_.map(products, (v, k) => {
    if (k.match("fresh_web_.*"))
        config[k] = {...config[k.replace("fresh_web_", "")]};
});

export default config;
